module.exports = __webpack_public_path__ + "static/media/opening-1.5c20eb9b.m4a";